// extracted by mini-css-extract-plugin
module.exports = {"pagination":"theme_pagination__Mg7Kw","dropdown":"theme_dropdown__zlNkC","resultInfo":"theme_resultInfo__aRkAc","button":"theme_button__XRBIT"};